import { useState } from "react";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { ActivateCardsSigningPayload, SigningAction, ViewPinSigningPayload } from "models/signing";
import { SigningForm } from "./SigningForm";

interface SigningModalBaseProps {
  handleModalHide: () => void;
  title: string;
  submitLabel: string;
  savingLabel?: string;
  renderContent: (signingSessionId: string, onReset: () => void) => React.ReactNode;
}

type SigningModalProps = SigningModalBaseProps & (
  | { action: SigningAction.VIEW_PIN; payload: ViewPinSigningPayload }
  | { action: SigningAction.ACTIVATE_CARDS; payload: ActivateCardsSigningPayload }
);

export default function SigningModal(props: SigningModalProps) {
  const [completedSigningSessionId, setCompletedSigningSessionId] = useState<string | null>(null);

  const isCompleted = !!completedSigningSessionId;

  return (
      <Modal
        show={true}
        size={"lg"}
        backdrop={'static'}
        onHide={props.handleModalHide}
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {props.title}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {
            isCompleted ? (
              props.renderContent(completedSigningSessionId!, () => setCompletedSigningSessionId(null))
            ) : (
              <SigningForm
                action={props.action}
                payload={props.payload}
                submitLabel={props.submitLabel}
                savingLabel={props.savingLabel}
                onSuccess={(signingSessionId) => setCompletedSigningSessionId(signingSessionId)}
                onCancel={props.handleModalHide}
              />
            )
          }
        </Modal.Body>
        {
          isCompleted && (
            <Modal.Footer className="d-flex flex-row align-items-end justify-content-around flex-wrap mb-1">
              <Button variant="outline-dark"
                onClick={props.handleModalHide}
                type="button"
                className={"d-flex align-items-center"}
              >
                <span className='px-2'>Tühista</span>
              </Button>
            </Modal.Footer>
          )
        }
      </Modal>
  )
}
